export var convertShortHexToFullHex = function convertShortHexToFullHex(hex) {
  var hexColor = hex.replace('#', '');
  if (hexColor.length === 3) {
    hexColor = hexColor.split('').map(function (hx) {
      return hx + hx;
    }).join('');
    return '#' + hexColor;
  }
};
export var rgba = function rgba() {
  var alpha, hex, hexInput, r, g, b;
  if (arguments.length === 1 || arguments.length === 2) {
    hex = arguments.length <= 0 ? undefined : arguments[0];
    hexInput = hex;
    if (hex.length === 4) {
      hexInput = convertShortHexToFullHex(hex);
    }
    r = parseInt(hexInput.slice(1, 3), 16);
    g = parseInt(hexInput.slice(3, 5), 16);
    b = parseInt(hexInput.slice(5, 7), 16);
    if (arguments.length === 2) {
      alpha = arguments.length <= 1 ? undefined : arguments[1];
    }
  }
  if (arguments.length === 3 || arguments.length === 4) {
    r = arguments.length <= 0 ? undefined : arguments[0];
    g = arguments.length <= 1 ? undefined : arguments[1];
    b = arguments.length <= 2 ? undefined : arguments[2];
    if (arguments.length === 4) {
      alpha = arguments.length <= 3 ? undefined : arguments[3];
    }
  }
  if (alpha) {
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha.toString().replace(/^0+/, '') + ')'; // removed leading zero from alpha
  } else {
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
};